import { c } from 'react-compiler-runtime';
import { isElement } from 'react-is';
import classes from './SegmentedControl.module.css.js';
import { clsx } from 'clsx';
import { jsx } from 'react/jsx-runtime';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import { Tooltip } from '../TooltipV2/Tooltip.js';

const SegmentedControlIconButton = t0 => {
  const $ = c(47);
  let Icon;
  let ariaLabel;
  let className;
  let description;
  let rest;
  let selected;
  let tooltipDirection;
  if ($[0] !== t0) {
    ({
      "aria-label": ariaLabel,
      icon: Icon,
      selected,
      className,
      description,
      tooltipDirection,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = ariaLabel;
    $[3] = className;
    $[4] = description;
    $[5] = rest;
    $[6] = selected;
    $[7] = tooltipDirection;
  } else {
    Icon = $[1];
    ariaLabel = $[2];
    className = $[3];
    description = $[4];
    rest = $[5];
    selected = $[6];
    tooltipDirection = $[7];
  }
  const tooltipFlagEnabled = useFeatureFlag("primer_react_segmented_control_tooltip");
  if (tooltipFlagEnabled) {
    let t1;
    if ($[8] !== className) {
      t1 = clsx(classes.Item, className);
      $[8] = className;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    const t2 = selected || undefined;
    const t3 = description ? undefined : "label";
    const t4 = description ? description : ariaLabel;
    const t5 = description ? ariaLabel : undefined;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = clsx(classes.Button, classes.IconButton);
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = clsx(classes.Content, "segmentedControl-content");
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== Icon) {
      t8 = isElement(Icon) ? Icon : /*#__PURE__*/jsx(Icon, {});
      $[12] = Icon;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== t8) {
      t9 = /*#__PURE__*/jsx("span", {
        className: t7,
        children: t8
      });
      $[14] = t8;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] !== rest || $[17] !== selected || $[18] !== t5 || $[19] !== t9) {
      t10 = /*#__PURE__*/jsx("button", {
        type: "button",
        "aria-current": selected,
        "aria-label": t5,
        className: t6,
        ...rest,
        children: t9
      });
      $[16] = rest;
      $[17] = selected;
      $[18] = t5;
      $[19] = t9;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== t10 || $[22] !== t3 || $[23] !== t4 || $[24] !== tooltipDirection) {
      t11 = /*#__PURE__*/jsx(Tooltip, {
        type: t3,
        text: t4,
        direction: tooltipDirection,
        children: t10
      });
      $[21] = t10;
      $[22] = t3;
      $[23] = t4;
      $[24] = tooltipDirection;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    let t12;
    if ($[26] !== t1 || $[27] !== t11 || $[28] !== t2) {
      t12 = /*#__PURE__*/jsx("li", {
        className: t1,
        "data-selected": t2,
        children: t11
      });
      $[26] = t1;
      $[27] = t11;
      $[28] = t2;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    return t12;
  } else {
    let t1;
    if ($[30] !== className) {
      t1 = clsx(classes.Item, className);
      $[30] = className;
      $[31] = t1;
    } else {
      t1 = $[31];
    }
    const t2 = selected || undefined;
    let t3;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = clsx(classes.Button, classes.IconButton);
      $[32] = t3;
    } else {
      t3 = $[32];
    }
    let t4;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = clsx(classes.Content, "segmentedControl-content");
      $[33] = t4;
    } else {
      t4 = $[33];
    }
    let t5;
    if ($[34] !== Icon) {
      t5 = isElement(Icon) ? Icon : /*#__PURE__*/jsx(Icon, {});
      $[34] = Icon;
      $[35] = t5;
    } else {
      t5 = $[35];
    }
    let t6;
    if ($[36] !== t5) {
      t6 = /*#__PURE__*/jsx("span", {
        className: t4,
        children: t5
      });
      $[36] = t5;
      $[37] = t6;
    } else {
      t6 = $[37];
    }
    let t7;
    if ($[38] !== ariaLabel || $[39] !== rest || $[40] !== selected || $[41] !== t6) {
      t7 = /*#__PURE__*/jsx("button", {
        type: "button",
        "aria-label": ariaLabel,
        "aria-current": selected,
        className: t3,
        ...rest,
        children: t6
      });
      $[38] = ariaLabel;
      $[39] = rest;
      $[40] = selected;
      $[41] = t6;
      $[42] = t7;
    } else {
      t7 = $[42];
    }
    let t8;
    if ($[43] !== t1 || $[44] !== t2 || $[45] !== t7) {
      t8 = /*#__PURE__*/jsx("li", {
        className: t1,
        "data-selected": t2,
        children: t7
      });
      $[43] = t1;
      $[44] = t2;
      $[45] = t7;
      $[46] = t8;
    } else {
      t8 = $[46];
    }
    return t8;
  }
};
SegmentedControlIconButton.__SLOT__ = Symbol('SegmentedControl.IconButton');

export { SegmentedControlIconButton, SegmentedControlIconButton as default };
